import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from 'react-bootstrap';
import { FIXED_TOP } from 'utils/sectionTypes';
import { BUILDER } from 'shared/abilities';
import { section } from '../decorators';
import styles from './AddOns.scss';

const ADDONS = 'Add ons';

const AddOns = ({ isEditable, children }) => {
  const widgets = React.Children.toArray(children);
  const widgetComponents = widgets.map((widget, i) => (
    <span className={styles.widget} key={i}>{widget}</span>
  ));

  if (!isEditable) {
    return (
      <div>{widgetComponents}</div>
    );
  }

  return (
    <Container fluid>
      <Row>
        <div className={styles.addOns}>
          <span className={styles.title}>Add-Ons</span>
          {widgetComponents}
        </div>
      </Row>
    </Container>
  );
};

AddOns.propTypes = {
  isEditable: PropTypes.bool.isRequired,
  children: PropTypes.node,
};

AddOns.defaultProps = {
  children: {},
};

const component = section(
  { name: ADDONS, region: FIXED_TOP, deprecated: true },
  {
    menu: { items: ['delete'] },
    subsections: [
      { accepts: ['PopUp'] },
    ],
  },
)(AddOns);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
